import React from 'react';
import PropTypes from 'prop-types';
import { useLeagueSettings } from '../../context/LeagueSettingsContext';
import HiddenText from '../HiddenText';
import styles from './styles/scheduled.module.css';
import sharedStyles from './styles/gameCard.module.css';
import { formatGameDateTime } from '../../utils/timeUtils';

const LockClosedIcon = () => (
  <svg className={styles.lockIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32px" height="32px">
    <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"/>
  </svg>
);

const LockedGameCard = ({ lock, weekNumber, className }) => {
  const { canSeeLockers } = useLeagueSettings();

  // Determine if we should show the username
  const showUsername = canSeeLockers(weekNumber, false, 0, 1);

  // Handle both regular lock objects and generic card objects
  const createdAt = lock.createdAt || lock.lockTime;
  const lockDateTime = formatGameDateTime(createdAt);

  return (
    <div
      className={`${styles.gameCard} ${sharedStyles.gameCardContainer} ${styles.lockedCard} ${className || ''}`}
      // Don't include data-game-id for generic cards to prevent them from being searchable
    >
      <div className={styles.header}>
        <span className={styles.gameInfo}>
          {lockDateTime.headerDate} • {lockDateTime.displayTime}
        </span>
      </div>

      <div className={styles.lockedContent}>
        <div className={styles.lockIconWrapper}>
          <LockClosedIcon />
        </div>
        <div className={styles.lockedText}>
          {showUsername ? (
            <span className={styles.username}>{lock.username}</span>
          ) : (
            <HiddenText
              type="locker"
              weekNumber={weekNumber}
              showTooltip={true}
            />
          )}
          <span className={styles.hasLockedText}> has locked</span>
        </div>
        <div className={styles.lockTimestamp}>
          {lockDateTime.headerDate}, {lockDateTime.displayTime}
        </div>
      </div>
    </div>
  );
};

LockedGameCard.propTypes = {
  lock: PropTypes.shape({
    id: PropTypes.number.isRequired,
    username: PropTypes.string.isRequired,
    userId: PropTypes.number.isRequired,
    gameId: PropTypes.number.isRequired,
    createdAt: PropTypes.string.isRequired,
    lockTime: PropTypes.string,
  }).isRequired,
  weekNumber: PropTypes.number.isRequired,
  className: PropTypes.string,
};

export default LockedGameCard;
